export default __webpack_public_path__ + "static/media/rollWindChart.d49b7e8a.png";